import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import eventData from "../data/eventData";
export default function EventSection() {
    const { t } = useTranslation();
    UseScrollAnimation();
    const showData = eventData.slice(0, 4).map((el, index) => (
        <div key={index} className="w-100 w-[31%] flex flex-col gap-[15px] bg-white rounded-[4px]">
            <div className="w-full h-[250px]">
                <img className="w-full h-full rounded-t-[4px]" src={el.mainImage} alt="" />
            </div>
            <div className="p-[10px] h-[150px] flex flex-col gap-[10px] justify-between">
                <div className="text-[#016e82] font-bold">{el.title}</div>
                <Link className="bg-[#016e82] text-center font-bold text-white p-2 rounded-[4px]" to={`/event-images/${el.id}`}>{t("Show Images")}</Link>
            </div>
        </div>
    ))
    return (
        <section className="relative py-[40px]">
            <div className="container flex flex-wrap gap-[20px]">
                {showData}
            </div>
        </section>
    );
}